import React, { useContext } from "react";
import { useLocation } from "react-router-dom";

import { Container, SignupItem } from "./styles";
import { AuthContext } from "../../context/AuthProvider";
import NavList from "../Navigation/NavList";
import { getModalLinkState } from "../Navigation/utils";
import { NAV_LOCATION } from "../Navigation/constants";
import { SIGNUP_REASONS, SIGNUP_SURFACES } from "../../analytics";

const MenuPopover = ({ toggleDropdown }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  // Hide the signup CTA from visitors who have ever been signed in on this
  // browser (a durable flag set by AuthProvider once a real user resolves).
  const isKnownUser = localStorage.getItem("bds_known_user") === "1";

  return (
    <Container>
      <NavList placement={NAV_LOCATION.MENU} onNavigate={toggleDropdown} />
      {user.role === "guest" && !isKnownUser && (
        <SignupItem
          onClick={toggleDropdown}
          to={{
            pathname: "/signup",
            state: {
              ...getModalLinkState(location),
              signupPrompt: {
                reason: SIGNUP_REASONS.NAV_CTA,
                surface: SIGNUP_SURFACES.MENU
              }
            }
          }}
        >
          <p>Sign Up</p>
        </SignupItem>
      )}
    </Container>
  );
};

export default MenuPopover;
